import { WorkingDaysConfiguration } from 'components/organisms/user-capacity';
import { DayOfWeek } from 'core/day-of-week';
import { ReminderConfiguration } from './api-configuration';
import { SubmissionHoursConfiguration } from './submission-hours';
import { TimeOfDay } from './time-of-day';

export type DueConfiguration = {
  day: DayOfWeek;
  time: TimeOfDay;
};
export interface ConfigMeta {
  submissionHours: SubmissionHoursConfiguration;
  categoryMandatory: boolean;
  predefinedActivitiesEnabled: boolean;
}

export interface IntegrationMeta {
  googleCalendarEnabled: boolean;
  outlookCalendarEnabled: boolean;
}

export interface EnabledSourcesConfiguration {
  ADHOC: boolean;
  MILESTONE: boolean;
  PHASE: boolean;
  TASK: boolean;
  PROJECT: boolean;
}

export interface ProjectReportTimeSettings {
  yourProjectOnly: boolean;
  projectWithStatuses: number[];
  onDaysWithTimeAllocation: boolean;
}

export interface FreezeTimesheetConfiguration {
  enabled: boolean;
  enableAfter?: string;
}

export interface LockApprovalConfiguration {
  enabled: boolean;
}

export interface CalendarTaskConfiguration {
  enabled: boolean;
}

export interface LockSettingConfiguration {
  freeze: FreezeTimesheetConfiguration;
  lock: LockApprovalConfiguration;
}

export enum TimesheetApprovalType {
  Manager = 'MANAGER',
  ProjectOwner = 'PROJECT_OWNER',
}

export interface TimeoffSettingConfiguration {
  isApproverInitiatedTimeOffEnabled: boolean;
}

export interface NonBillableHoursFlagSettingConfiguration {
  nonBillableHoursFlagForTimeAndMaterialProjectsEnabled: boolean;
  nonBillableHoursFlagForFixedFeeProjectsEnabled: boolean;
  nonBillableHoursFlagForSubscriptionProjectsEnabled: boolean;
}

export interface Configuration {
  capacityMinutes: number;
  due: DueConfiguration;
  reminder: ReminderConfiguration;
  workingDays: WorkingDaysConfiguration;
  configMeta: ConfigMeta;
  integrationMeta: IntegrationMeta;
  enabledSourceTypes: EnabledSourcesConfiguration;
  lockSetting: LockSettingConfiguration;
  approvalSetting: TimesheetApprovalType;
  projectReportTimeSettings: ProjectReportTimeSettings;
  calendarTaskSetting: CalendarTaskConfiguration;
  timeOffSetting: TimeoffSettingConfiguration;
  nonBillableHoursFlagSetting: NonBillableHoursFlagSettingConfiguration;
}
